import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import ToggleSwitch from './form/ToggleSwitch';

const ThemeToggle = () => {
  const { isModernUI, toggleTheme } = useTheme();

  return (
    <div className="theme-toggle">
      <ToggleSwitch
        id="theme-toggle"
        isOn={isModernUI}
        handleToggle={toggleTheme}
        onColor="#6366f1"
        offColor="#85f49c"
        onLabel="Modern"
        offLabel="Classic"
      />
    </div>
  );
};

export default ThemeToggle;